export default "__VITE_ASSET__0df620da__"